import { render, staticRenderFns } from "./CommunityModule.vue?vue&type=template&id=67f69fb1&scoped=true&"
import script from "./CommunityModule.vue?vue&type=script&lang=ts&"
export * from "./CommunityModule.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityModule.vue?vue&type=style&index=0&id=67f69fb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f69fb1",
  null
  
)

export default component.exports